import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  height: 5rem;\n  padding-top: 2rem;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  button {\n    margin-left: 2rem;\n    width: 140px;\n    letter-spacing: 3px;\n    span {\n      padding: 0;\n    }\n  }\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  width: 60%;\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n     flex-direction: column;\n  "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n      width: 100%;\n    "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n\n  > div {\n    width: 48%;\n    ", "\n  }\n\n  ", "\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    flex-direction: column;\n    $ > div {\n      margin-bottom: 10px;\n    }\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 60%;\n  ", "\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  svg {\n    top: -3px;\n    left: -1px;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: none;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    font-size: 20px;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    justify-content: center;\n    font-size: 24px;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    font-size: 24px;\n    line-height: 120%;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  padding: 1rem 0;\n  width: 100%;\n  font-size: 30px;\n  display: flex;\n  justify-content: space-between;\n  height: 4rem;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  height: auto;\n  margin-bottom: 1.5rem;\n  display: flex;\n  justify-content: space-between;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  align-items: center;\n  justify-content: flex-start;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  & > div:first-child {\n    &::before{\n      content: '';\n      display: block;\n      position: absolute;\n      width: 100%\n      height: 1px;\n      background-color: ", ";\n      opacity: 0.1;\n      bottom: 0;\n    }\n    position: relative;\n    padding-bottom: 3rem;\n    \n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
export var Container = styled.div(_templateObject(), function (props) {
  return props.theme.colors.blackDeep;
});
export var Wrapper = styled.div(_templateObject2());
export var TileWrapper = styled.div(_templateObject3());
export var Header = styled.div(_templateObject4(), media.xxLargeScreen(_templateObject5()), media.mediumScreen(_templateObject6()), media.smallScreen(_templateObject7()));
export var HeaderSmall = styled.div(_templateObject8());
export var Content = styled.div(_templateObject9());
export var ContentOneLine = styled.div(_templateObject10(), media.smallScreen(_templateObject11()));
export var ContentEdit = styled.div(_templateObject12());
export var ContentEditOneLine = styled.div(_templateObject13(), media.smallScreen(_templateObject14()), media.smallScreen(_templateObject15()));
export var ContentExtendInput = styled.div(_templateObject16());
export var Form = styled.form(_templateObject17());
export var FormButtons = styled.div(_templateObject18());